// ===================================================================
// FORTEEN DESIGN SYSTEM - REACT COMPONENTS (MVP VERSION)
// Simplified components for Voice Sprint MVP
// ===================================================================

import React from 'react';

// ===================================================================
// BUTTON COMPONENT
// ===================================================================

export const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'base', 
  fullWidth = false,
  disabled = false,
  onClick,
  ...props 
}) => {
  const baseClass = 'btn';
  const variantClass = `btn-${variant}`;
  const sizeClass = size !== 'base' ? `btn-${size}` : '';
  const widthClass = fullWidth ? 'btn-full' : '';
  
  const className = [baseClass, variantClass, sizeClass, widthClass]
    .filter(Boolean)
    .join(' ');
  
  return (
    <button 
      className={className} 
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

// ===================================================================
// BADGE COMPONENT
// ===================================================================

export const Badge = ({ level, children }) => {
  return (
    <span className={`badge badge-${level}`}>
      {children}
    </span>
  );
};

// ===================================================================
// PROGRESS TRACKER COMPONENT
// ===================================================================

export const ProgressTracker = ({ current, total, gradient = 'primary' }) => {
  const percentage = (current / total) * 100;
  const gradientClasses = {
    primary: '',
    secondary: 'progress-fill-secondary',
    success: 'progress-fill-success'
  };
  
  return (
    <div className="progress-bar">
      <div 
        className={`progress-fill ${gradientClasses[gradient]}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

// ===================================================================
// AUDIO TOGGLE COMPONENT
// ===================================================================

export const AudioToggle = ({ isAudioMode, onToggle }) => {
  return (
    <div className="toggle-container">
      <span className="font-semibold">📖 Read</span>
      <label className="toggle">
        <input 
          type="checkbox" 
          checked={isAudioMode}
          onChange={onToggle}
        />
        <span className="toggle-slider" />
      </label>
      <span className="font-semibold">🔊 Listen</span>
    </div>
  );
};

export default {
  Button,
  Badge,
  ProgressTracker,
  AudioToggle
};
